var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-down" }, [
    _vm.domainNameFlag("vava", this.domain) ||
    _vm.domainNameFlag("echo", this.domain)
      ? _c(
          "div",
          { staticClass: "vava-container" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("lang.down.becomeAHost"))),
            ]),
            _c(
              "div",
              { staticClass: "phone-code flexDirection" },
              [
                _vm.domainNameFlag("vava", this.domain)
                  ? [
                      _vm.lang == "ar"
                        ? _c("img", {
                            staticClass: "logo",
                            attrs: {
                              src: require("@/assets/packageAssets/views/P4_Page/Down/vava/down_bg_ar.png"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            staticClass: "logo",
                            attrs: {
                              src: require("@/assets/packageAssets/views/P4_Page/Down/vava/down_bg.png"),
                              alt: "",
                            },
                          }),
                    ]
                  : _vm._e(),
                _vm.domainNameFlag("echo", this.domain)
                  ? [
                      _vm.lang == "ar"
                        ? _c("img", {
                            staticClass: "logo",
                            attrs: {
                              src: require("@/assets/packageAssets/views/P4_Page/Down/echo/down_bg_ar.png"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            staticClass: "logo",
                            attrs: {
                              src: require("@/assets/packageAssets/views/P4_Page/Down/echo/down_bg.png"),
                              alt: "",
                            },
                          }),
                    ]
                  : _vm._e(),
                _c("div", { staticClass: "code-box" }, [
                  _c("div", { staticClass: "code-tit" }, [
                    _vm._v(_vm._s(_vm.$t("lang.down.invitationCode"))),
                  ]),
                  _c("div", { staticClass: "code-num" }, [
                    _vm._v(" " + _vm._s(_vm.code) + " "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/packageAssets/views/P4_Page/Down/copy_icon.png"),
                        alt: "",
                      },
                      on: { click: _vm.copy },
                    }),
                  ]),
                ]),
              ],
              2
            ),
            _c("div", { staticClass: "get-app" }, [
              _vm._v(_vm._s(_vm.$t("lang.down.getTheApp"))),
            ]),
            this.appNameFlag("echo", this.appName) && !this.isIOS()
              ? [
                  _c("div", { staticClass: "down-btn" }, [
                    _c("div", { staticClass: "down-btn-box" }, [
                      _vm._m(0),
                      _c("img", {
                        staticClass: "down-btn-img",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P4_Page/Down/google_btn.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDownloadEcho(true)
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "down-btn-box" }, [
                      _vm._m(1),
                      _c("img", {
                        staticClass: "down-btn-img",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P4_Page/Down/app_store.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDownloadEcho(false)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              : [
                  _c("div", { staticClass: "down-btn" }, [
                    _c("div", { staticClass: "down-btn-box" }, [
                      _vm._m(2),
                      _c("img", {
                        staticClass: "down-btn-img",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P4_Page/Down/google_btn.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDownload("vava")
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "down-btn-box" }, [
                      _vm._m(3),
                      _c("img", {
                        staticClass: "down-btn-img",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P4_Page/Down/app_store.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDownload("echo")
                          },
                        },
                      }),
                    ]),
                  ]),
                ],
            _c("div", { staticClass: "become-tit" }, [
              _vm._v(_vm._s(_vm.$t("lang.down.howToBecomeAHost"))),
            ]),
            _c("div", { staticClass: "footer" }, [
              _c("div", { staticClass: "footer-box" }, [
                _c(
                  "div",
                  { staticClass: "footer-content" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("lang.down.tit1")))]),
                    this.appNameFlag("echo", this.appName) && !this.isIOS()
                      ? [
                          _c("i", [
                            _vm._v(_vm._s(_vm.$t("lang.down.tit1con3"))),
                          ]),
                        ]
                      : [
                          _c("i", [
                            _vm._v(_vm._s(_vm.$t("lang.down.tit1con1"))),
                          ]),
                        ],
                    _c("i", [_vm._v(_vm._s(_vm.$t("lang.down.tit1con2")))]),
                  ],
                  2
                ),
                _c("div", { staticClass: "footer-content content2" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.down.tit2")))]),
                  _c("i", [_vm._v(_vm._s(_vm.$t("lang.down.tit2con")))]),
                ]),
              ]),
              _c("div", { staticClass: "footer-content" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.down.tit3")))]),
                _c("i", [_vm._v(_vm._s(_vm.$t("lang.down.tit3con1")))]),
                _c("i", { staticClass: "keynote" }, [
                  _vm._v(_vm._s(_vm.$t("lang.down.tit3con2"))),
                ]),
              ]),
            ]),
          ],
          2
        )
      : _vm._e(),
    _vm.domainNameFlag("joychat", this.domain)
      ? _c("div", { staticClass: "joychat-container" }, [
          _vm._m(4),
          _c("div", { staticClass: "titie" }, [
            _vm._v(" " + _vm._s(_vm.$t("lang.down.becomeA")) + " "),
            _c("i", [_vm._v(_vm._s(_vm.$t("lang.down.host")))]),
          ]),
          _vm.lang == "ar"
            ? _c("img", {
                staticClass: "down_bg",
                attrs: {
                  src: require("@/assets/packageAssets/views/P4_Page/Down/joychat/down_bg.png"),
                  alt: "",
                },
              })
            : _c("img", {
                staticClass: "down_bg",
                attrs: {
                  src: require("@/assets/packageAssets/views/P4_Page/Down/joychat/down_bg_ar.png"),
                  alt: "",
                },
              }),
          _c("div", { staticClass: "code" }, [
            _vm._v(" " + _vm._s(_vm.$t("lang.down.inviteCode")) + ": "),
            _c("i", [_vm._v(_vm._s(_vm.code))]),
            _c("span", { staticClass: "copy", on: { click: _vm.copy } }, [
              _vm._v(_vm._s(_vm.$t("lang.copy"))),
            ]),
          ]),
          _c("div", { staticClass: "down", on: { click: _vm.download } }, [
            _vm._v(_vm._s(_vm.$t("lang.down.tit"))),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "down-logo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/packages/echo/app-logo.png"),
          alt: "",
        },
      }),
      _c("span", [_vm._v("Echo")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "down-logo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/packages/echo/app-logo.png"),
          alt: "",
        },
      }),
      _c("span", [_vm._v("Echo")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "down-logo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/packages/vava/app-logo.png"),
          alt: "",
        },
      }),
      _c("span", [_vm._v("Vava")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "down-logo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/packages/echo/app-logo.png"),
          alt: "",
        },
      }),
      _c("span", [_vm._v("Echo(Vava)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "head" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("@/assets/packageAssets/packages/joychat/app-logo.png"),
          alt: "",
        },
      }),
      _c("img", {
        staticClass: "imee",
        attrs: {
          src: require("@/assets/packageAssets/views/P4_Page/Down/joychat/title.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }